//
//
//
//
//
//
//
//
//
//
//
//
//

import List from "@/components/RegionAccount/List";
export default {
  name: "CityManageList",
  components: { List },
  data() {
    return {
      accountType: "city",
    };
  },
};
